import React from "react";
import { Card } from "react-bootstrap";
import { BsLinkedin } from "react-icons/bs";

export const TeamCard = ({ ...team }) => {
  return (
    <Card className="text-center h-100 shadow-team rounded-24 mw-300 mx-auto">
      <div className="p-3">
        <Card.Img
          src={team.img}
          alt={team.name}
          width="100%"
          height="auto"
          className="img-fluid obj-fit-cover obj-position-center overflow-hidden mw-150px rounded-72"
        />
      </div>
      <Card.Body>
        <Card.Title className="text-black h6">{team.name}</Card.Title>
        <p className="m-0">{team.designation}</p>
        <p className="m-0">{team.qualification}</p>
      </Card.Body>
      <Card.Footer className="text-center pt-0 border-0 bg-transparent  ">
        <a href={team.linkedinUrl} className="h1">
          <BsLinkedin />
        </a>
      </Card.Footer>
    </Card>
  );
};
